// ─── Feuille : CRÉER un compte depuis le panneau ──────────────────
// Crée le compte Auth (API REST, pour ne pas déconnecter l'admin) puis son
// profil Firestore, directement actif. Le mot de passe est provisoire : la
// personne le change via le lien « mot de passe oublié ».
import React, { useEffect, useMemo, useState } from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, ChoixPuces, stylesForm, useUI, useT, ecouterPlans, nomPlan } from '@mop/core';
import { creerCompte } from './services/comptes';
import { PLANS } from './services/admin';

export default function FeuilleNouveauCompte({ visible, onFermer, onCree }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [email, setEmail] = useState('');
  const [prenom, setPrenom] = useState('');
  const [mdp, setMdp] = useState('');
  const [plan, setPlan] = useState('gratuit');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  // Noms réels des forfaits (config/plans, pilotés par l'administration) — les
  // identifiants bruts (`gratuit`, `famille`…) ne sont pas ce qu'on montre.
  const [plansCfg, setPlansCfg] = useState({});
  useEffect(() => ecouterPlans(setPlansCfg), []);

  useEffect(() => {
    if (!visible) return;
    setEmail(''); setPrenom(''); setMdp(''); setPlan('gratuit'); setErr(''); setBusy(false);
  }, [visible]);

  const emailOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim());
  const valide = emailOk && mdp.length >= 6 && !busy;

  async function creer() {
    if (!valide) return;
    setBusy(true); setErr('');
    try {
      const r = await creerCompte({ email, motDePasse: mdp, prenom, plan });
      onCree?.(r); onFermer?.();
    } catch (e) { setErr(e?.message || String(e)); }
    setBusy(false);
  }

  return (
    <Feuille visible={visible} titre={t('admin.nouveauCompte')} emoji="➕" hauteur={0.6} onFermer={onFermer}
      action={{ icone: '💾', label: t('commun.ajouter'), disabled: !valide, onPress: creer }}>
      {!!err && <Text style={s.err}>⚠️ {err}</Text>}
      <Text style={s.lbl}>{t('profil.email')}</Text>
      <TextInput style={s.input} value={email} onChangeText={setEmail} autoFocus
        autoCapitalize="none" keyboardType="email-address" autoCorrect={false}
        placeholder="nom@exemple.fr" placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('admin.prenom')}</Text>
      <TextInput style={s.input} value={prenom} onChangeText={setPrenom} autoCapitalize="words"
        placeholder={t('admin.phPrenom')} placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('admin.mdpProvisoire')}</Text>
      <TextInput style={s.input} value={mdp} onChangeText={setMdp} autoCapitalize="none"
        placeholder={t('admin.phMdp')} placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('admin.forfait')}</Text>
      <ChoixPuces value={plan} onChange={setPlan} options={PLANS.map(p => ({ id: p, label: nomPlan(plansCfg, p) }))} />
      <Text style={s.aide}>{t('admin.nouveauCompteAide')}</Text>
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  err: { fontSize: 12.5, color: UI.danger, fontWeight: '700', marginBottom: 6 },
  aide: { fontSize: 11.5, color: UI.faint, marginTop: 12, lineHeight: 16 },
});
